/**
 * Global asset constants for the GenAI Platform
 */

import defaultAvatarUrl from '../assets/images/default-avatar.jpg';



// Default user avatar bundled with the frontend app.
export const DEFAULT_AVATAR_URL = defaultAvatarUrl;

export const resolveAvatarUrl = (avatarUrl?: string | null): string => {
    const value = String(avatarUrl || '').trim();
    if (!value) {
        return DEFAULT_AVATAR_URL;
    }

    return value.replace(/^http:\/\//, 'https://');
};

// Other defaults can go here (e.g. default cover image)
export const DEFAULT_COVER_URL = 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=1600&q=80';
